import {
  conditionalRender
} from "./chunk.XNLGRHFL.js";
import {
  emit
} from "./chunk.HM4ZRC4T.js";
import {
  __decorateClass,
  component_styles_default,
  theme_styles_default
} from "./chunk.U4VUMZVF.js";

// src/sub-components/info-label/info-label.ts
import { LitElement as LitElement3, html as html3 } from "lit";
import { customElement as customElement3, property as property3 } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// src/sub-components/info-label/info-label.styles.ts
import { css } from "lit";
var info_label_styles_default = css`
	${theme_styles_default}
	${component_styles_default}

	:host {
		display: inline-block;
		width: auto;
	}

	.info-label {
		display: flex;
		justify-content: space-between;
	}

	.info-label__textual-info {
		display: inline-flex;
		align-items: flex-end;
	}

	.info-label__labels {
		display: flex;
		flex-direction: column;
		row-gap: var(--yotpo-spacing-small);
	}

	.info-label__char-count {
		display: inline-block;
		align-self: flex-end;
	}

	.info-label yotpo-info-icon {
		padding-left: var(--yotpo-spacing-small);
		height: var(--yotpo-icon-size);
		font-size: var(--yotpo-icon-size);
		flex-shrink: 0;
	}

	.info-label.info-label--medium yotpo-info-icon,
	.info-label.info-label--large yotpo-info-icon {
		margin-bottom: var(--yotpo-spacing-tiny);
	}
`;

// src/sub-components/info-icon/info-icon.ts
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

// src/sub-components/info-icon/info-icon.styles.ts
import { css as css2 } from "lit";
var info_icon_styles_default = css2`
	${theme_styles_default}
	${component_styles_default}

	.info-icon {
		color: var(--yotpo-font-color-light-secondary);
		width: 16px; /* 1rem */
		height: 16px; /* 1rem */
	}

	.info-icon yotpo-icon {
		font-size: 16px; /* 1rem */
	}
`;

// src/sub-components/info-icon/info-icon.ts
var YotpoInfoIcon = class extends LitElement {
  constructor() {
    super(...arguments);
    this.tooltipText = "";
  }
  render() {
    return html`
			<div class="info-icon">
				<yotpo-tooltip text=${this.tooltipText} hoist=${true}>
					<yotpo-icon name="info"></yotpo-icon>
				</yotpo-tooltip>
			</div>
		`;
  }
};
YotpoInfoIcon.styles = info_icon_styles_default;
__decorateClass([
  property({ reflect: true })
], YotpoInfoIcon.prototype, "tooltipText", 2);
YotpoInfoIcon = __decorateClass([
  customElement("yotpo-info-icon")
], YotpoInfoIcon);

// src/sub-components/char-count/char-count.ts
import { LitElement as LitElement2, html as html2 } from "lit";
import { customElement as customElement2, property as property2 } from "lit/decorators.js";

// src/sub-components/char-count/char-count.styles.ts
import { css as css3 } from "lit";
var char_count_styles_default = css3`
	${theme_styles_default}
	${component_styles_default}
`;

// src/sub-components/char-count/char-count.ts
var YotpoCharCount = class extends LitElement2 {
  constructor() {
    super(...arguments);
    this.maxChar = 0;
    this.charCount = 0;
  }
  render() {
    return html2`
			<div class="yotpo-theme-light">
				<div class="yotpo-text-small yotpo-text-secondary">${this.charCount}/${this.maxChar}</div>
			</div>
		`;
  }
};
YotpoCharCount.styles = char_count_styles_default;
__decorateClass([
  property2({ type: Number, reflect: true })
], YotpoCharCount.prototype, "maxChar", 2);
__decorateClass([
  property2({ type: Number, reflect: true })
], YotpoCharCount.prototype, "charCount", 2);
YotpoCharCount = __decorateClass([
  customElement2("yotpo-char-count")
], YotpoCharCount);

// src/sub-components/info-label/info-label.ts
var YotpoInfoLabel = class extends LitElement3 {
  constructor() {
    super(...arguments);
    this.text = "";
    this.labelSize = "small" /* small */;
    this.subtitle = "";
    this.tooltipText = "";
    this.maxChar = 0;
    this.charCount = 0;
    this.actionDisabled = false;
  }
  emitActionEvent() {
    emit(this, "yotpo-main-action" /* mainAction */);
  }
  handleSubtitleLinkAction(event) {
    event.stopPropagation();
    emit(this, "yotpo-link-action" /* linkAction */, { detail: event.detail });
  }
  render() {
    return html3`
			<div
				class=${classMap({
      "info-label": true,
      "info-label--small": this.labelSize === "small" /* small */,
      "info-label--medium": this.labelSize === "medium" /* medium */,
      "info-label--large": this.labelSize === "large" /* large */
    })}
			>
				<div class="info-label__textual-info">
					<span class="info-label__labels yotpo-theme-light">
						${conditionalRender(this.text, html3`<yotpo-label
								size=${this.labelSize}
								color=${this.labelColor}
								text=${this.text}
							></yotpo-label>`)}
						${conditionalRender(this.text && this.subtitle, html3`<yotpo-label
								size=${this.labelSize}
								color=${this.subtitleColor}
								text=${this.subtitle}
								hypertext
								@yotpo-link-action=${this.handleSubtitleLinkAction}
							></yotpo-label>`)}
					</span>
					${conditionalRender(this.tooltipText, html3`<yotpo-info-icon tooltipText=${this.tooltipText}></yotpo-icon>`)}
				</div>
				${conditionalRender(this.maxChar, html3`<div class="info-label__char-count">
						<yotpo-char-count maxChar=${this.maxChar} charCount=${this.charCount}></yotpo-char-count>
					</div>`)}
				${conditionalRender(this.action, html3` <div class="info-label__action">
						<yotpo-text-button
							name="action-button"
							size="${"small" /* small */}"
							@click=${this.emitActionEvent}
							.disabled=${this.actionDisabled}
							>${this.action}</yotpo-text-button
						>
					</div>`)}
			</div>
		`;
  }
};
YotpoInfoLabel.styles = info_label_styles_default;
__decorateClass([
  property3({ reflect: true })
], YotpoInfoLabel.prototype, "text", 2);
__decorateClass([
  property3({ reflect: true })
], YotpoInfoLabel.prototype, "labelColor", 2);
__decorateClass([
  property3({ reflect: true })
], YotpoInfoLabel.prototype, "labelSize", 2);
__decorateClass([
  property3({ reflect: true })
], YotpoInfoLabel.prototype, "subtitle", 2);
__decorateClass([
  property3({ reflect: true })
], YotpoInfoLabel.prototype, "subtitleColor", 2);
__decorateClass([
  property3({ reflect: true })
], YotpoInfoLabel.prototype, "tooltipText", 2);
__decorateClass([
  property3({ type: Number, reflect: true })
], YotpoInfoLabel.prototype, "maxChar", 2);
__decorateClass([
  property3({ type: Number, reflect: true })
], YotpoInfoLabel.prototype, "charCount", 2);
__decorateClass([
  property3({ type: String, reflect: true })
], YotpoInfoLabel.prototype, "action", 2);
__decorateClass([
  property3({ type: Boolean, reflect: true })
], YotpoInfoLabel.prototype, "actionDisabled", 2);
YotpoInfoLabel = __decorateClass([
  customElement3("yotpo-info-label")
], YotpoInfoLabel);
